import { Link } from "react-router-dom";

export default function ColdFlareStudios() {
  return (
    <main className="cold-flare-studios-page">
      <section className="text-area">
        <h1>ColdFlare Studios</h1>

        <p>
          Explore my games, development updates, and the growing
          ColdFlare universe.
        </p>

        <div className="coldflare-links">
          <Link className="page-button" to="/devlog">
            View Dev Log
          </Link>
          <Link className="page-button" to="/arcade">Enter Arcade</Link>
        </div>
      </section>
      
      <section className="text-area">
        <h2>News</h2>
        <p>New game added to the arcade! <br/>
        Neon Apex: Training Circuit is now playable alongside Neon Lanes and the rest of the ColdFlare arcade collection.<br/><br/>

        Test your steering skills in a compact top-down racing course created as an early training project for the future of Neon Apex.<br/><br/>

        Play it now In the arcade!</p>
      </section>
    </main>
  );
}